import { CartOffer } from "./cartOffer.model";
import { CompanyPeriodicity } from "./companyPeriodicity.model";
import { Offer } from "./offer.model";
import { PaymentFingerprint } from "./paymentFingerprint.model";
import { ServiceInstance } from "./service-instance.model";
import { ClassOrString, Parameter, Verylys } from "./verylys";

export enum RENTAL_RENEW_TYPE {
    AUTO = "auto_renew",
    MANUAL = "manual_renew"
}

export enum RENTAL_STATUS {
    AVAILABLE = "available",
    SUSPENDED = "suspended",
    EXPIRING = "expiring",
    EXPIRED = "expired",
    CREATING = "creating",
    SUSPENDING = "suspending",
    PRE_ORDERED = "pre_ordered"
}

export interface Rental extends Verylys {
    _id: string;
    friendly_id: string;
    parameters: {
        renew_type: Parameter<RENTAL_RENEW_TYPE>,
        periodicity_unit: Parameter<string>,
        periodicity_value: Parameter<number>,
        status: Parameter<RENTAL_STATUS>
        can_be_renewed: Parameter<boolean>,
        started_at: Parameter<string>,
        ending_at: Parameter<string>,
        custom_name: Parameter<string>
        was_preordered: Parameter<boolean>;
    }

    service_instances: ClassOrString<ServiceInstance>[];
    offer: ClassOrString<Offer>;
    payment_fingerprint: ClassOrString<PaymentFingerprint>;
    last_cart_offer: ClassOrString<CartOffer>;
    autorenew_company_periodicity: ClassOrString<CompanyPeriodicity>;
}